import { getAccountPayment } from "../../../api/services";
import { useQuery } from "react-query";

export const useAccountPayment = (accountNumber: string, paymentId: string) => {
  return useQuery(
    ["accounts/payments", { accountNumber, paymentId }],
    getAccountPayment,
    {
      enabled: !!accountNumber && !!paymentId,
    },
  );
};
